import React, { useState } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    Form,
    Button,
    Alert,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '@/shared/contexts/AuthContext';
import usePageTitle from '@/shared/hooks/usePageTitle';

function ForgotPassword() {
    usePageTitle('Reset your password');
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const { resetPassword } = useAuth();

    async function handleSubmit(e) {
        e.preventDefault();

        try {
            setMessage('');
            setError('');
            setLoading(true);
            await resetPassword(email);
            setMessage('Check your email for password reset instructions');
        } catch (_err) {
            setError(
                'Failed to send reset email. Please check your email address.'
            );
        } finally {
            setLoading(false);
        }
    }

    return (
        <Container className="py-5">
            <Row className="justify-content-center">
                <Col md={6} lg={5}>
                    <Card>
                        <Card.Body className="p-4">
                            <h1 className="h2 text-center mb-4">
                                Reset Password
                            </h1>
                            {error && <Alert variant="danger">{error}</Alert>}
                            {message && (
                                <Alert variant="success">{message}</Alert>
                            )}
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        autoComplete="email"
                                        value={email}
                                        onChange={(e) =>
                                            setEmail(e.target.value)
                                        }
                                        required
                                    />
                                </Form.Group>
                                <Button
                                    type="submit"
                                    variant="primary"
                                    className="w-100"
                                    disabled={loading}
                                >
                                    {loading ? 'Sending...' : 'Reset Password'}
                                </Button>
                            </Form>
                            <div className="text-center mt-3">
                                <Link to="/login">Back to Log In</Link>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default ForgotPassword;
